import imm from 'immutable';

import * as u from './utils';
import {
    CONTEXT_TYPE_PRODUCT
} from '@evo/chat-core';

export function isThereNewMessages(chats) {
    return (chats || imm.List()).filter(u.newMsgCondition).size > 0;
}


export function getDialogOwner(state) {
    return u.getSocketStore(state).get('userId');
}

export function newMsgInCurrentDialog(currentChat) {
    return !!(
        currentChat &&
        currentChat.get('history') &&
        currentChat.get('history').find((msg) => {
            return msg.get('id') > currentChat.get('last_read_counter') &&
                !currentChat.get('noMsgSent');
        })
    );
}

export function newMsgInChat(chat) {
    return (
        chat.get('last_message_counter') > chat.get('last_read_counter') &&
        !chat.get('noMsgSent')
    );
}

export function firstCntxInCurrentDialog(currentChat) {
    return (currentChat.get('history') || imm.Map()).find(
        (msg) => msg.get('context_item_type') === CONTEXT_TYPE_PRODUCT
    );
}

export function lastCntxInCurrentDialog(currentChat) {
    return u.findLastContextOutOfViewPort(
        (currentChat || imm.Map()).get('history')) || null;
}

export function isInDialog(currentChatRoom) {
    return Boolean(currentChatRoom.get('room_name'));
}

export function dialogInputRows(chatMsgText) {
    return u.countInputRows(chatMsgText);
}

export function isDialogInputEmpty(chatMsgText) {
    return u.isEmpty(chatMsgText.split('\n').join(''));
}

export function modifiedRoomRespMedian(modifiedCompanyRoom) {
    return modifiedCompanyRoom && modifiedCompanyRoom.response_median;
}

export function getFilteredChats(chats, status, role) {
    return (chats || imm.List()).filter((chat) => (
        chat.get('role') === role &&
        chat.get('room_status') === status
    ));
}

export function hasUnreadMessage(chats, status=null, role=null) {
    return Boolean((chats || imm.List()).find((chat) => (
        (!role || chat.get('role') === role) &&
        (!status || chat.get('room_status') === status) &&
        newMsgInChat(chat)
    )));
}
